import { Routes } from '@angular/router';
import { provideOrganisationStore } from '@app/store/organisation';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const organisationsModalRoutes: Routes = [
    {
        path: 'organisations/add',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideOrganisationStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'organisations/view/:id',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideOrganisationStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'organisations/edit/:id',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideOrganisationStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
